import Big from "big.js";

export class MoneyConstants {
  static ROUNDING_METHOD = Big.roundHalfEven;

  static DISPLAY_DECIMAL_PLACES = 2;

  static CALCULATE_DECIMAL_PLACES_CENTS = 2;
}
